import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { axiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listCustomerAddresses = (queryString) => {
  if (queryString) {
    return axios.get(
      `${getV1RootUrl()}/customer/${customerId()}/address?${queryString}`,
      axiosHeader()
    );
  }
  return axios.get(
    `${getV1RootUrl()}/customer/${customerId()}/address`,
    axiosHeader()
  );
};

export const getCustomerAddress = (customerAddressId) =>
  axios.get(
    `${getV1RootUrl()}/customer/${customerId()}/address/${customerAddressId}`,
    axiosHeader()
  );

export const getCustomerAddressDefault = () =>
  axios.get(
    `${getV1RootUrl()}/customer/${customerId()}/address/default`,
    axiosHeader()
  );

export const addCustomerAddress = (customerAddress) =>
  axios.post(
    `${getV1RootUrl()}/customer/${customerId()}/address/`,
    customerAddress,
    axiosHeader()
  );

export const editCustomerAddress = (customerAddressId, customerAddress) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId()}/address/${customerAddressId}`,
    customerAddress,
    axiosHeader()
  );

export const deleteCustomerAddress = (customerAddressId) =>
  axios.delete(
    `${getV1RootUrl()}/customer/${customerId()}/address/${customerAddressId}`,
    axiosHeader()
  );

const customerId = () => jwtDecode(Cookies.get('customerToken')).sub;
